import { SVGProps } from 'react';

const ArrowDownFromLine = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M19 3H5m7 18V7m6 8-6 6-6-6"
    />
  </svg>
);
export default ArrowDownFromLine;
